import React, { useState } from 'react';
import { ConsumptionControlTable } from './ConsumptionSettings_Components.js';
import { t } from './i18n.js';
//import  sampleConfig from './sample_config.json'

const ConsumptionSettings = ({ initialConsumptionConfigs, onSave, saveStatus }) => {
  //console.log (initialConsumptionConfigs)
  const [consumptionConfig, setConsumptionConfig] = useState(initialConsumptionConfigs);
  //const [consumptionConfig, setConsumptionConfig] = useState(sampleConfig);

  if (!consumptionConfig || Object.keys(consumptionConfig).length === 0) {
    return <div>{t('common.loading')}</div>;
  }

  const handleToggleEnabled = (serviceId, field, isEnabled) => {
    setConsumptionConfig((prevConfig) => {
      const updatedService = {
        ...prevConfig[serviceId],
        [field]: isEnabled,
      };
      return { ...prevConfig, [serviceId]: updatedService };
    });
  };

  const handleControlToggle = (serviceId, isEnabled) => {
    setConsumptionConfig((prevConfig) => {
      const updatedService = {
        ...prevConfig[serviceId],
        controller: {
          ...prevConfig[serviceId].controller,
          enabled: isEnabled,
        },
      };
      return { ...prevConfig, [serviceId]: updatedService };
    });
  };

  const handleOverrideToggle = (serviceId, isEnabled) => {
    setConsumptionConfig((prevConfig) => {
      const updatedService = {
        ...prevConfig[serviceId],
        override: {
          ...prevConfig[serviceId].override,
          enabled: isEnabled,
        },
      };
      return { ...prevConfig, [serviceId]: updatedService };
    });
  };

  const handleFixedRulesChange = (serviceId, settingType, value) => {
    const parsedValue = value === '' ? 0 : parseInt(value, 10);

    setConsumptionConfig((prevConfig) => {
      const updatedService = {
        ...prevConfig[serviceId],
        [settingType]: {
          ...prevConfig[serviceId][settingType],
          rules: parsedValue,
        },
      };
      return { ...prevConfig, [serviceId]: updatedService };
    });
  };

  const handleOverrideHoursChange = (serviceId, value) => {
    const parsedValue = value === '' ? 0 : parseInt(value, 10);

    setConsumptionConfig((prevConfig) => {
      const updatedService = {
        ...prevConfig[serviceId],
        override: {
          ...prevConfig[serviceId].override,
          hours: parsedValue,
        },
      };
      return { ...prevConfig, [serviceId]: updatedService };
    });
  };

  const handleRulesArrayChange = (serviceId, ruleIndex, value) => {
    const parsedValue = value === '' ? 0 : parseInt(value, 10);

    setConsumptionConfig((prevConfig) => {
      const service = prevConfig[serviceId];
      // Create a deep copy of the rules array
      const updatedRules = [...service.controller.rules];

      // Update the specific rule hours
      updatedRules[ruleIndex] = {
        ...updatedRules[ruleIndex],
        hours: parsedValue
      };

      const updatedService = {
        ...service,
        controller: {
          ...service.controller,
          rules: updatedRules
        }
      };

      return { ...prevConfig, [serviceId]: updatedService };
    });
  };

  const handleSlotChange = (serviceId, timeWindow, value) => {
    const parsedValue = value === '' ? 0 : parseInt(value, 10);

    setConsumptionConfig((prevConfig) => {
      const service = prevConfig[serviceId];

      const updatedService = {
        ...service,
        controller: {
          ...service.controller,
          rules: {
            ...service.controller.rules,
            [timeWindow]: parsedValue
          }
        }
      };

      return { ...prevConfig, [serviceId]: updatedService };
    });
  };

  const handleCurrentAChange = (serviceId, value) => {
    const parsedValue = value === '' ? 0 : parseInt(value, 10);
    
    setConsumptionConfig((prevConfig) => {
      const service = prevConfig[serviceId];
      
      // If actor doesn't exist, create it
      const currentActor = service.actor || {};
      
      const updatedService = {
        ...service,
        actor: {
          ...currentActor,
          currentA: parsedValue
        }
      };
      
      return { ...prevConfig, [serviceId]: updatedService };
    });
  };

  const handleOverrideTypeChange = (serviceId, type) => {
    // When changing to fixed_hours, ensure hours is initialized if it doesn't exist
    setConsumptionConfig((prevConfig) => {
      const currentOverride = prevConfig[serviceId].override;
      const updatedOverride = {
        ...currentOverride,
        type: type,
      };
      
      // Initialize hours to 1 if switching to fixed_hours and hours is not set
      if (type === 'fixed_hours' && (currentOverride.hours === undefined || currentOverride.type !== 'fixed_hours')) {
        updatedOverride.hours = currentOverride.hours || 1;
      }
      
      const updatedService = {
        ...prevConfig[serviceId],
        override: updatedOverride,
      };
      
      return { ...prevConfig, [serviceId]: updatedService };
    });
  };

  const handleSave = () => {
    // Send the updated consumptionConfig to the parent component
    onSave(consumptionConfig);
  };

  // Extract services from the config (excluding metadata)
  const services = Object.entries(consumptionConfig)
    .filter(([key]) => key !== 'metadata')
    .map(([id, service]) => ({ id, ...service }));

  return (
    <div className="container">
      <h2>{t('consumption.title')}</h2>

      <ConsumptionControlTable
        services={services}
        metadata={consumptionConfig.metadata}
        onToggleEnabled={handleToggleEnabled}
        onControlToggle={handleControlToggle}
        onOverrideToggle={handleOverrideToggle}
        onFixedRulesChange={handleFixedRulesChange}
        onOverrideHoursChange={handleOverrideHoursChange}
        onOverrideTypeChange={handleOverrideTypeChange}
        onRulesArrayChange={handleRulesArrayChange}
        onSlotChange={handleSlotChange}
        onCurrentAChange={handleCurrentAChange}
      />

      <p></p>
      {saveStatus === 'success' && <p><i>{t('common.saveSuccess')}</i></p>}
      {saveStatus === 'error' && <p>{t('common.saveError')}</p>}
      <button onClick={handleSave}>{t('common.save')}</button>
    </div>
  );
};

export default ConsumptionSettings;
